import { Sparkles, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ValuesGateBannerProps {
  onNavigateToValues: () => void;
}

export function ValuesGateBanner({ onNavigateToValues }: ValuesGateBannerProps) {
  return (
    <div className="rounded-lg border border-amber-500/30 bg-amber-500/10 p-4 mb-6">
      <div className="flex items-start gap-3">
        <div className="rounded-full bg-amber-500/20 p-2 shrink-0">
          <Sparkles className="w-5 h-5 text-amber-400" />
        </div>
        <div className="flex-1 space-y-2">
          <p className="text-sm font-medium text-amber-200">
            Complete your values discovery to unlock full functionality
          </p>
          <p className="text-xs text-amber-200/70">
            You can preview this section, but creating and editing content requires completing your values assessment first.
          </p>
          <Button
            size="sm"
            onClick={onNavigateToValues}
            className="gap-1.5 mt-1"
          >
            <Sparkles className="w-3.5 h-3.5" />
            Complete Values Discovery
            <ArrowRight className="w-3.5 h-3.5" />
          </Button>
        </div>
      </div>
    </div>
  );
}
